// Configuration file for API endpoints and keys
// This ensures the values are available even if .env doesn't load properly

const config = {
    COMIC_VINE_API_KEY: process.env.REACT_APP_COMIC_VINE_API_KEY || '5cc6cc327e3999e3cbb2d3691fae9337be2fe6e1',
    FIREBASE_FUNCTION_URL: process.env.REACT_APP_FIREBASE_FUNCTION_URL || 'https://us-central1-comic-fb9b6.cloudfunctions.net/comicVineProxy',
};

// Log to console for debugging
console.log('Config loaded:', config);
console.log('Environment variables available:', {
    REACT_APP_COMIC_VINE_API_KEY: process.env.REACT_APP_COMIC_VINE_API_KEY,
    REACT_APP_FIREBASE_FUNCTION_URL: process.env.REACT_APP_FIREBASE_FUNCTION_URL
});

export default config;